import { render, staticRenderFns } from "./HBrandPlugin.vue?vue&type=template&id=9a0c5d0c&scoped=true&"
import script from "./HBrandPlugin.vue?vue&type=script&lang=js&"
export * from "./HBrandPlugin.vue?vue&type=script&lang=js&"
import style0 from "./HBrandPlugin.vue?vue&type=style&index=0&id=9a0c5d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0c5d0c",
  null
  
)

export default component.exports